import React from "react";
import { Box, Divider, Modal, Typography } from "@mui/material";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import "rsuite/dist/rsuite.min.css";
import "./datePickerStyles.css";
import { Button, DateRangePicker } from "rsuite";
import moment from "moment";

const orderStatus = [
  "ALL",
  "COMPLETED",
  "RETURNED",
  "READY FOR PICKUP",
  "PROCESSING",
  "DELIVERED TO HOTEL",
  "CANCELLED",
  "IN TRANSIT TO HOTEL",
  "IN TRANSIT TO WANDEROBE",
];

const FilterModal = ({
  open,
  onClose,
  selectedStatuses,
  handleStatusClick,
  selectedDateRange,
  setSelectedDateRange,
  setSelectedStatuses,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box className='filter-modal-container'>
        <Box>
          <Box className='filter-modal-header'>
            <Typography className='modal-title'>Filter</Typography>
            <ClearOutlinedIcon onClick={onClose} />
          </Box>
          <Box className='filter-date-range'>
            <Typography className='modal-filter-by-date-range-heading'>
              Filter by Date range
            </Typography>
            <Box
              className='date-picker-container'
              sx={{ position: "relative", marginTop: "10px" }}
            >
              <DateRangePicker
                value={selectedDateRange}
                onChange={(value) => setSelectedDateRange(value)}
                placeholder='Select date range'
                className='date-range-picker'
                format='MM/dd/yyyy'
                cleanable
                block
                renderValue={(value, placeholder) => {
                  if (!value || value.length !== 2 || !value[0] || !value[1]) {
                    return placeholder || "Select date range";
                  }

                  return `${moment(value[0]).format("MM/DD/YYYY")} - ${moment(value[1]).format("MM/DD/YYYY")}`;
                }}
              />
            </Box>
          </Box>
          <Divider sx={{ margin: "20px 0px" }} />
          <Box>
            <Typography className='modal-filter-by-date-range-heading'>
              Filter by Order status
            </Typography>
            <Box className='filter-by-order-status'>
              {orderStatus.map((element) => {
                const isSelected = selectedStatuses.includes(element);

                return (
                  <Box
                    key={element}
                    className={`order-status-tag ${isSelected ? "selected" : ""}`}
                    onClick={() => handleStatusClick(element)}
                    sx={{ cursor: "pointer" }}
                  >
                    <Typography className='order-status-tag-text'>
                      {element.charAt(0).toUpperCase() +
                        element.slice(1).toLowerCase()}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
        <Box className='modal-filter-btns'>
          <Button
            variant='outlined'
            className='cancel-all-btn'
            onClick={() => {
              setSelectedDateRange(null);
              setSelectedStatuses(["ALL"]);
              onClose();
            }}
          >
            Cancel all
          </Button>
          <Button variant='contained' className='apply-filter-btn' onClick={onClose}>Apply filter</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FilterModal;
